import React from 'react';
import Chip from '@mui/material/Chip';
import HeaderImg from '../../../assets/images/header.png';
import Avatar from '@mui/material/Avatar';
import CardAvatar from '../../../assets/images/card-avatar.png';
import { Asset } from '../../../types/assets';
import { CustomColors } from '../../../theme';
import useMediaQuery from '@mui/material/useMediaQuery';

interface props {
  asset: Asset;
}

const Header = ({ asset }: props) => {
  const isSmallScreen = useMediaQuery('(max-width: 1000px)');
  const isMDScreen = useMediaQuery('(max-width: 900px) and (min-width: 800px)');

  const avatarContainer: React.CSSProperties = {
    position: 'absolute',
    top: !isSmallScreen ? '150px' : '100px',
    left: !isSmallScreen ? '13%' : '10px',
    padding: '10px',
    width: '80px',
    height: '70px',
    zIndex: 1,
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '10px',
  };

  const textContainer: React.CSSProperties = {
    position: 'absolute',
    top: !isSmallScreen ? '200px' : '150px',
    left: !isSmallScreen ? '12%' : '10px',
    padding: '10px',
    zIndex: 1,
  };

  const avatarStyles = {
    width: '60px',
    height: '50px',
    objectFit: 'cover',
  };

  return (
    <div
      style={{
        paddingLeft: isSmallScreen ? '0px' : '10px',
        paddingRight: isSmallScreen ? '0px' : '10px',
      }}
    >
      <div style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '400px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            borderRadius: isSmallScreen ? '0px' : '20px',
          }}
        />
        <img
          src={
            asset?.company?.cover && asset?.company?.cover.length > 0
              ? asset?.company?.cover[0]
              : HeaderImg
          }
          style={{
            width: '100%',
            height: '400px',
            objectFit: 'cover',
            borderRadius: isSmallScreen ? '0px' : '20px',
          }}
          alt="Header"
        />

        <div style={avatarContainer}>
          <Avatar
            variant="square"
            alt="Logo"
            src={asset?.company?.logo ? asset?.company?.logo : CardAvatar}
            sx={avatarStyles}
          />
        </div>
        <div style={textContainer}>
          <h1 style={{ color: '#fff' }}>{asset?.company?.companyName}</h1>

          {asset?.company?.tags &&
            asset?.company?.tags.length > 0 &&
            asset?.company?.tags?.map((tag, index) => {
              return (
                <Chip
                  label={tag}
                  key={index}
                  style={{
                    backgroundColor: CustomColors.grey900,
                    color: CustomColors.white,
                  }}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Header;
